import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "../../../shared/api/query-subscription-options";
import type { IDiseaseDto } from "../shared";
import { Disease } from "../shared/models/disease";

export const diseasesApiSlice = createApi({
  reducerPath: "api-diseases",
  // https://github.com/reduxjs/redux-toolkit/discussions/2347#discussioncomment-2978038
  refetchOnFocus: false,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  baseQuery,
  tagTypes: ["DiseasesList"],
  endpoints: (builder) => ({
    fetchDiseases: builder.query<Disease[], void>({
      queryFn: pagedQueryFn<IDiseaseDto, Disease[]>({ url: "DiseasesV2" }, (dtos) => {
        const models: Disease[] = dtos.map((dto) => {
          const model = new Disease(dto.id);
          model.updateFromDto(dto);
          return model;
        });
        models.sort((a: Disease, b: Disease) => a.name.localeCompare(b.name));
        return models;
      }),
      providesTags: ["DiseasesList"],
    }),
  }),
});

const useDiseasesEndpoint = diseasesApiSlice.endpoints.fetchDiseases.useQuery;

export function useFetchDiseases(
  options?: QuerySubscriptionOptions<typeof useDiseasesEndpoint>
) {
  return useDiseasesEndpoint(undefined, options);
}
